import React, { useEffect, useState } from "react";
import clsx from "clsx";
import { Popover, OverlayTrigger } from "react-bootstrap";
import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import List from "@material-ui/core/List";
import CssBaseline from "@material-ui/core/CssBaseline";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Avatar from "@material-ui/core/Avatar";
import Grid from "@material-ui/core/Grid";
import Badge from "@material-ui/core/Badge";
import NotificationsIcon from "@material-ui/icons/Notifications";
import { Link, NavLink } from "react-router-dom";
import avatar from "../static/img_avatar.png";
import { useHistory } from "react-router-dom";
import authService from "../services/authService";
import PeopleAltIcon from "@material-ui/icons/PeopleAlt";
import BusinessRoundedIcon from '@mui/icons-material/BusinessRounded';
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import ReceiptIcon from "@material-ui/icons/Receipt";
import { getProfile } from "../services/userService";
import "./Navbar.css";
import "./AdminSideNavBar.css";
import GenericThemeSwitch from "./GenericThemeSwitch";
import isEmptyObject from "../utils/isEmptyObject";
import { connect, useSelector } from "react-redux";
import { setCurrentUser } from "../redux/user/user.actions";
import BookIcon from "@material-ui/icons/Book";
import AccountBalanceIcon from "@material-ui/icons/AccountBalance";
import { getHomeCMS } from "../services/adminServices";
import Tooltip from "@material-ui/core/Tooltip";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { matchPath } from "react-router";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import PoetNewlogopen from "../static/loginlogo.png";
import PetPenLogo from "../static/POET_Logo_Pen.png";
import HomeIcon from '@mui/icons-material/Home';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import {
  exitScreen,
  fullscreen,
} from "../redux/manageFullSizeEditor/fullSizeEditor.action";
import { Button } from "@material-ui/core";
import ChatIcon from "@material-ui/icons/Chat";
import RateReviewIcon from "@mui/icons-material/RateReview";
import Poetlogopen from "../static/POET_Logo_Pen.png";

const drawerWidth = 240;

const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: 'blue',
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
}))(Tooltip);

const useStyles = makeStyles((theme) => ({
  avatar: {
    margin: 10,
  },
  bigAvatar: {
    margin: 10,
    width: 60,
    height: 60,
  },
  grow: {
    flexGrow: 1,
  },
  root: {
    display: "flex",
  },
  appBar: {
    backgroundColor: "#ccced1 !important",
    boxShadow: 'none',
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(99% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 38,
    [theme.breakpoints.down("sm")]: {
      marginRight: 0,
    },
  },
  hide: {
    display: "none",
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: "nowrap",
    position: "relative",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    zIndex: theme.zIndex.drawer,
    [theme.breakpoints.down("sm")]: {
      position: "fixed",
      height: "100%",
      top: 0,
      left: 0,
      zIndex: theme.zIndex.drawer + 1,
      transform: "translateX(-100%)",
      transition: theme.transitions.create("transform", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    [theme.breakpoints.down("sm")]: {
      transform: "translateX(0)",
    },
  },
  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9) + 1,
    },
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
  },
  toolbarB: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
  },
  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "flex",
    },
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  sectionMobile: {
    display: "flex",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  active: {
    backgroundColor: theme.palette.action.selected,
  },
  iconButton: {
    "&:hover": {
      backgroundColor: "#B4D9FF",
    },
  },
}));

function AdminHeader(props) {
  const classes = useStyles();
  let history = useHistory();
  const [anchorEl, setAnchorEl] = React.useState(false);
  const [profilePic, setProfilePic] = useState("");
  const [emailId, setemailId] = useState("");
  const [user, setUser] = useState("");
  const theme = useTheme();
  const [open, setOpen] = React.useState();
  const [isAdmin, setAdmin] = React.useState(false);
  const [cms, setCms] = useState({});
  const location = useLocation();

  const [bottomText, setBottomText] = useState("")
  const [selectedMenu, setSelectedMenu] = useState('Professional Editing Tool');

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [isFullscreen, setIsFullscreen] = useState(false);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const mobileView = windowWidth <= 600;

  const formatDate = () => {
    const options = { month: 'short', day: 'numeric', year: 'numeric' };
    const date = new Date();
    const month = date.toLocaleDateString('en-US', { month: 'short' });
    const day = date.toLocaleDateString('en-US', { day: 'numeric' });
    const year = date.toLocaleDateString('en-US', { year: 'numeric' });
    return `${month} ${day} | ${year}`;
  };

  useEffect(() => {
    if (mobileView) {
      handleDrawerClose()
    }
  }, []);

  useEffect(() => {
    const currentPath = window.location.pathname;
    const capitalizeFirstLetter = (string) => {
      return string.charAt(0).toUpperCase() + string.slice(1);
    };

    switch (currentPath) {
      case '/accountsettings':
        setSelectedMenu('Account Settings');
        break;
      case '/admindashboard':
        const capitalizedUsername = capitalizeFirstLetter(user);
        setSelectedMenu(`Welcome ${capitalizedUsername}`);
        setBottomText(`${formatDate()}`);
        break;
      case '/manageuser':
        setSelectedMenu('Manage Users');
        break;
      case '/manageorganizations':
        setSelectedMenu('Manage Organizations');
        break;
      case '/subscription':
        setSelectedMenu('Manage Subscription');
        break;
      case '/manageinvoices':
        setSelectedMenu('Manage Invoices');
        break;
      case '/adminBlogs':
        setSelectedMenu('Manage Blogs');
        break;
      case '/adminUserLogs':
        setSelectedMenu('Logs');
        break;
      case '/costumHome':
        setSelectedMenu('Customise Landing');
        break;
      case '/managereviews':
        setSelectedMenu("Manage Reviews");
        break;
      case '/promptsGenerator':
        setSelectedMenu('Prompts Generator')
        break;
      default:
        setSelectedMenu('Professional Editing Tool');
    }
  }, [user]);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const menuId = "primary-search-account-menu";
  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const enterFullscreen = () => {
    const element = document.documentElement;
    if (element.requestFullscreen) {
      element.requestFullscreen();
    } else if (element.mozRequestFullScreen) {
      element.mozRequestFullScreen();
    } else if (element.webkitRequestFullscreen) {
      element.webkitRequestFullscreen();
    } else if (element.msRequestFullscreen) {
      element.msRequestFullscreen();
    }
    setIsFullscreen(true);
  };

  const exitFullscreen = () => {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    }
    setIsFullscreen(false);
  };

  const toggleFullscreen = () => {
    if (!isFullscreen) {
      enterFullscreen();
    } else {
      exitFullscreen();
    }
  };

  const getCms = async () => {
    let cms = await getHomeCMS();
    setCms(cms.data);
  };

  useEffect(() => {
    const user = authService.getCurrentUser();
    if (user) {
      if (user.isAdmin === true) {
        setAdmin(true);
      }
    }
    displyPic();
    getCms();
  }, []);

  const displyPic = async () => {
    let user;
    const { currentUser, setCurrentUser } = props;
    if (currentUser && !isEmptyObject(currentUser)) {
      user = { ...currentUser };
    } else {
      user = await getProfile();
      user = user.data;
      setCurrentUser(user);
    }
    const { display_picture } = user;
    setProfilePic(display_picture);
    setemailId(user.email);
    setUser(user.username);
  };

  const dropdown_popover = (
    <Popover id="popover-basic" style={{ zIndex: "9999" }}>
      <Popover.Content>
        <NavLink
          to={{ pathname: "/accountsettings" }}
          style={{ color: "black" }}
        >
          <MenuItem
            onClick={handleMenuClose}
            className={isUrlMatch("/accountsettings") && "background-black"}
          >
            Account Settings
          </MenuItem>
        </NavLink>
        <NavLink to={{ pathname: "/logout" }} style={{ color: "black" }}>
          <MenuItem onClick={handleMenuClose}>Log Out</MenuItem>
        </NavLink>
      </Popover.Content>
    </Popover>
  );

  const getThemeSwitch = () => {
    return <GenericThemeSwitch />;
  };

  function isUrlMatch(path) {
    return matchPath(location.pathname, {
      path,
      exact: true,
      strict: false,
    });
  }

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar
        style={{ backgroundColor: "black" }}
        id="appBar"
        position="fixed"
        className={clsx(classes.appBar, {
          [classes.appBarShift]: open,
        })}
      >
        <Toolbar>
          <LightTooltip title="Click to Expand">
            <IconButton
              style={{ color: "#4d4f5c" }}
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              edge="start"
              className={clsx(classes.menuButton, {
                [classes.hide]: open,
              })}
              id="normalsidenav"
            >
              <img
                alt="logo"
                className="img-fluid lcss"
                src={Poetlogopen}
                style={{
                  width: "40px",
                  height: "50px",
                  objectFit: "contain",
                }}
              ></img>
            </IconButton>
          </LightTooltip>

          {mobileView && !open ? (
            <p>
              {selectedMenu !== 'Professional Editing Tool' ? (
                <>
                  <text
                    style={{
                      fontFamily: "Roboto-Regular, sans-serif !important;",
                      fontWeight: 600,
                      fontSize: "18px",
                      marginBottom: "0px",
                      color: '#0b4fe7',
                    }}
                    className="text-custom"
                  >
                    {selectedMenu}
                  </text>
                </>
              ) : (
                <>
                  <text
                    style={{
                      fontFamily: "Roboto-Regular, sans-serif !important;",
                      lineHeight: "1.18",
                      fontWeight: 600,
                      fontSize: "18px",
                      marginRight: "5px",
                    }}
                    className="text-custom"
                  >
                    SYNTHIUM
                  </text>
                  <small
                    style={{
                      fontFamily: "Roboto-Regular, sans-serif !important;",
                      lineHeight: "1.18",
                      fontSize: "18px",
                      fontWeight: 300,
                    }}
                    className="text-custom"
                  >
                    ADMIN
                  </small>
                </>
              )}
            </p>
          ) : (
            <Typography
              className="main-title"
              variant="h6"
              noWrap
              style={{ color: "#4d4f5c", marginLeft: "0px" }}
            >
              <p>
                {selectedMenu !== 'Professional Editing Tool' ? (
                  <>
                    <text
                      style={{
                        fontFamily: "Roboto-Regular, sans-serif !important;",
                        lineHeight: "1.18",
                        fontWeight: 600,
                        fontSize: "28px",
                        color: '#0b4fe7',
                      }}
                      className="text-custom"
                    >
                      {selectedMenu}
                    </text>
                    <br />
                    {bottomText && (
                      <small
                        style={{
                          fontFamily: "Roboto-Regular, sans-serif !important;",
                          lineHeight: "1.18",
                          fontSize: "14px",
                          fontWeight: 300,
                        }}
                        className="text-custom"
                      >
                        {bottomText}
                      </small>
                    )}
                  </>
                ) : (
                  <>
                    <text
                      style={{
                        fontFamily: "Roboto-Regular, sans-serif !important;",
                        lineHeight: "1.18",
                        fontWeight: 600,
                        fontSize: "22px",
                        marginRight: "5px",
                      }}
                      className="text-custom"
                    >
                      SYNTHIUM
                    </text>
                    <small
                      style={{
                        fontFamily: "Roboto-Regular, sans-serif !important;",
                        lineHeight: "1.18",
                        fontSize: "22px",
                        fontWeight: 300,
                      }}
                      className="text-custom"
                    >
                      ADMIN PANEL
                    </small>
                  </>
                )}
              </p>
            </Typography>
          )}

          <div className={classes.grow} />

          <div className={classes.sectionDesktop}>
            <div style={{ marginTop: "6%" }}>
              <LightTooltip
                title={isFullscreen ? "Exit Fullscreen" : "Go Fullscreen"}
              >
                <Button
                  onClick={toggleFullscreen}
                  style={{
                    fontSize: mobileView ? "10px" : "16px",
                    color: "#1976d2",
                  }}
                >
                  {isFullscreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
                </Button>
              </LightTooltip>

              {getThemeSwitch()}
            </div>
            <div>
              <Grid container justify="center" alignItems="center">
                <OverlayTrigger
                  trigger="click"
                  placement="bottom"
                  overlay={dropdown_popover}
                  rootClose={true}
                >
                  <LightTooltip title={user} onClick={handleProfileMenuOpen}>
                    <Avatar
                      aria-controls={menuId}
                      aria-haspopup="true"
                      alt={user}
                      src={profilePic ? profilePic : avatar}
                      id="profilePic"
                      className={`${classes.avatar} profilePic point`}
                      color="inherit"
                    />
                  </LightTooltip>
                </OverlayTrigger>
              </Grid>
            </div>
          </div>

          <div className={classes.sectionMobile}>
            <LightTooltip
              title={isFullscreen ? "Exit Fullscreen" : "Go Fullscreen"}
            >
              <Button
                onClick={toggleFullscreen}
                style={{
                  fontSize: mobileView ? "10px" : "16px",
                  color: "#1976d2",
                }}
              >
                {isFullscreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
              </Button>
            </LightTooltip>

            {getThemeSwitch()}

            <OverlayTrigger
              trigger="click"
              placement="bottom"
              overlay={dropdown_popover}
              rootClose={true}
            >
              <Avatar
                aria-label="account of current user"
                aria-controls={menuId}
                onClick={handleProfileMenuOpen}
                aria-haspopup="true"
                alt={user}
                src={profilePic ? profilePic : avatar}
                id="profilePic"
                className={`${classes.avatar} point`}
                data-toggle="tooltip"
                data-placement="bottom"
                title={user}
                color="inherit"
              />
            </OverlayTrigger>
          </div>
        </Toolbar>
      </AppBar>

      <Drawer
        variant="permanent"
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: open,
          [classes.drawerClose]: !open,
        })}
        classes={{
          paper: clsx(
            {
              [classes.drawerOpen]: open,
              [classes.drawerClose]: !open,
            },
            "gradient-background"
          ),
        }}
        open={open}
      >
        <div
          className="corner-top-navbar"
          style={{
            display: "flex",
            alignItems: "center",
            backgroundColor: "rgba(0, 0, 0, 0)",
            justifyContent: "space-between",
            padding: theme.spacing(0, 1),
            minHeight: "64px",
          }}
        >
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === "rtl" ? (
              <MenuIcon style={{ color: "#1976d2", fontSize: "25px" }} />
            ) : (
              <MenuIcon style={{ color: "#1976d2", fontSize: "25px" }} />
            )}
          </IconButton>
         <img
            alt="logo"
            className="img-fluid lcss"
            src={PoetNewlogopen}
            style={{
              // width: "110%",
              height: "100%",
              marginRight: "50px",
            }}
          ></img>
        </div>

        <List
          className="drawerMenu pointer"
          id="menuList"
          style={{
            borderTopRightRadius: "50px",
            background: "linear-gradient(135deg, #000000, #0c7ff3ff)",
          }}
        >
          <NavLink
            className="sidenavbar-textlink"
            to={{ pathname: "/admindashboard" }}
            style={{ border: "1px solid transparent", fontWeight: 600 }}
          >
            <ListItem
              className={
                isUrlMatch("/admindashboard") ? "background-red" : "hvr-pulse"
              }
            >
              <ListItemIcon className="drawerMenu" style={{ color: "white" }}>
                <LightTooltip title={open ? "" : "Dashboard"}>
                  <HomeIcon
                    className={
                      isUrlMatch("/admindashboard") ? "iconCol" : "hvr-pulse"
                    }
                    style={{ fontSize: 24 }}
                  />
                </LightTooltip>
              </ListItemIcon>
              <Typography style={{ fontWeight: 500 }}>Dashboard</Typography>
            </ListItem>
          </NavLink>

          <NavLink
            className="sidenavbar-textlink"
            to={{ pathname: "/manageuser" }}
            style={{ border: "1px solid transparent", fontWeight: 600 }}
          >
            <ListItem
              className={
                isUrlMatch("/manageuser") ? "background-red" : "hvr-pulse"
              }
            >
              <ListItemIcon className="drawerMenu" style={{ color: "white" }}>
                <LightTooltip title={open ? "" : "Manage Users"}>
                  <svg
                    className={
                      isUrlMatch("/manageuser")
                        ? "bi bi-person-fill-check iconCol"
                        : "bi bi-person-fill-check hvr-pulse"
                    }
                    xmlns="http://www.w3.org/2000/svg"
                    width="22px"
                    height="22px"
                    fill="currentColor"
                    viewBox="0 0 18 18"
                    style={{ color: "white" }}
                  >
                    <path d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m1.679-4.493-1.335 2.226a.75.75 0 0 1-1.174.144l-.774-.773a.5.5 0 0 1 .708-.708l.547.548 1.17-1.951a.5.5 0 1 1 .858.514M11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0" />
                    <path d="M2 13c0 1 1 1 1 1h5.256A4.5 4.5 0 0 1 8 12.5a4.5 4.5 0 0 1 1.544-3.393Q8.844 9.002 8 9c-5 0-6 3-6 4" />
                  </svg>
                </LightTooltip>
              </ListItemIcon>
              <Typography style={{ fontWeight: 500 }}>Manage Users</Typography>
            </ListItem>
          </NavLink>

          <NavLink
            className="sidenavbar-textlink"
            to={{ pathname: "/manageorganizations" }}
            style={{ border: "1px solid transparent", fontWeight: 600 }}
          >
            <ListItem
              className={
                isUrlMatch("/manageorganizations") ? "background-red" : "hvr-pulse"
              }
            >
              <ListItemIcon className="drawerMenu" style={{ color: "white" }}>
                <LightTooltip title={open ? "" : "Manage Organizations"}>
                  <BusinessRoundedIcon
                    className={
                      isUrlMatch("/manageorganizations") ? "iconCol" : "hvr-pulse"
                    }
                    style={{ fontSize: 24 }}
                  />
                </LightTooltip>
              </ListItemIcon>
              <Typography style={{ fontWeight: 500 }}>Manage Organizations</Typography>
            </ListItem>
          </NavLink>

          <NavLink
            className="sidenavbar-textlink"
            to={{ pathname: "/subscription" }}
            style={{ border: "1px solid transparent", fontWeight: 600 }}
          >
            <ListItem
              className={
                isUrlMatch("/subscription") ? "background-red" : "hvr-pulse"
              }
            >
              <ListItemIcon className="drawerMenu" style={{ color: "white" }}>
                <LightTooltip title={open ? "" : "Manage Subscription"}>
                  <CurrencyExchangeIcon
                    className={isUrlMatch("/subscription") ? "iconCol" : "hvr-pulse"}
                    style={{ fontSize: 24 }}
                  />
                </LightTooltip>
              </ListItemIcon>
              <Typography style={{ fontWeight: 500 }}>Manage Subscription</Typography>
            </ListItem>
          </NavLink>

          <NavLink
            className="sidenavbar-textlink"
            to={{ pathname: "/manageinvoices" }}
            style={{ border: "1px solid transparent", fontWeight: 600 }}
          >
            <ListItem
              className={
                isUrlMatch("/manageinvoices") ? "background-red" : "hvr-pulse"
              }
            >
              <ListItemIcon className="drawerMenu" style={{ color: "white" }}>
                <LightTooltip title={open ? "" : "Manage Invoices"}>
                  <ReceiptIcon
                    className={
                      isUrlMatch("/manageinvoices") ? "iconCol" : "hvr-pulse"
                    }
                    style={{ fontSize: 24 }}
                  />
                </LightTooltip>
              </ListItemIcon>
              <Typography style={{ fontWeight: 500 }}>Manage Invoices</Typography>
            </ListItem>
          </NavLink>

          {/* Manage Reviews Section */}
          {/* <NavLink
            className="sidenavbar-textlink"
            to={{ pathname: "/managereviews" }}
            style={{ border: "1px solid transparent", fontWeight: 600 }}
          >
            <ListItem
              className={
                isUrlMatch("/managereviews") ? "background-red" : "hvr-pulse"
              }
            >
              <ListItemIcon className="drawerMenu" style={{ color: "white" }}>
                <LightTooltip title={open ? "" : "Manage Reviews"}>
                  <RateReviewIcon
                    className={
                      isUrlMatch("/managereviews") ? "iconCol" : "hvr-pulse"
                    }
                    style={{ fontSize: 24 }}
                  />
                </LightTooltip>
              </ListItemIcon>
              <Typography style={{ fontWeight: 500 }}>Manage Reviews</Typography>
            </ListItem>
          </NavLink> */}

          {/* <NavLink
            className="sidenavbar-textlink"
            to={{ pathname: "/adminBlogs" }}
            style={{ border: "1px solid transparent", fontWeight: 600 }}
          >
            <ListItem
              className={
                isUrlMatch("/adminBlogs") || isUrlMatch("/blogpreview/:id") ? "background-red" : "hvr-pulse"
              }
            >
              <ListItemIcon className="drawerMenu" style={{ color: "white" }}>
                <LightTooltip title={open ? "" : "Manage Blogs"}>
                  <BookIcon
                    className={
                      isUrlMatch("/adminBlogs") || isUrlMatch("/blogpreview/:id") ? "iconCol" : "hvr-pulse"
                    }
                    style={{ fontSize: 24 }}
                  />
                </LightTooltip>
              </ListItemIcon>
              <Typography style={{ fontWeight: 500 }}>Manage Blogs</Typography>
            </ListItem>
          </NavLink> */}

          <NavLink
            className="sidenavbar-textlink"
            to={{ pathname: "/adminUserLogs" }}
            style={{ border: "1px solid transparent", fontWeight: 600 }}
          >
            <ListItem
              className={
                isUrlMatch("/adminUserLogs") ? "background-red" : "hvr-pulse"
              }
            >
              <ListItemIcon className="drawerMenu" style={{ color: "white" }}>
                <LightTooltip title={open ? "" : "Logs"}>
                  <ReceiptIcon
                    className={
                      isUrlMatch("/adminUserLogs") ? "iconCol" : "hvr-pulse"
                    }
                    style={{ fontSize: 24 }}
                  />
                </LightTooltip>
              </ListItemIcon>
              <Typography style={{ fontWeight: 500 }}>Logs</Typography>
            </ListItem>
          </NavLink>

          <NavLink
  className="sidenavbar-textlink"
  to={{ pathname: "/promptsGenerator" }}
  style={{ border: "1px solid transparent", fontWeight: 600 }}
>
  <ListItem
    className={
      isUrlMatch("/promptsGenerator") ? "background-red" : "hvr-pulse"
    }
  >
    <ListItemIcon className="drawerMenu" style={{ color: "white" }}>
      <LightTooltip title={open ? "" : "Prompts Generator"}>
        <ChatIcon
          className={
            isUrlMatch("/promptsGenerator") ? "iconCol" : "hvr-pulse"
          }
          style={{ fontSize: 24 }}
        />
      </LightTooltip>
    </ListItemIcon>
    <Typography style={{ fontWeight: 500 }}>
      Prompts Generator
    </Typography>
  </ListItem>
</NavLink>


          {/* <NavLink
            className="sidenavbar-textlink"
            to={{ pathname: "/costumHome" }}
            style={{ border: "1px solid transparent", fontWeight: 600 }}
          >
            <ListItem
              className={
                isUrlMatch("/costumHome") ? "background-red" : "hvr-pulse"
              }
            >
              <ListItemIcon className="drawerMenu" style={{ color: "white" }}>
                <LightTooltip title={open ? "" : "Customize Landing Page"}>
                  <AccountBalanceIcon
                    className={isUrlMatch("/costumHome") ? "iconCol" : "hvr-pulse"}
                    style={{ fontSize: 24 }}
                  />
                </LightTooltip>
              </ListItemIcon>
              <Typography style={{ fontWeight: 500 }}>
                Customize Landing Page
              </Typography>
            </ListItem>
          </NavLink> */}
        </List>
        <Divider />
      </Drawer>

      <main className={classes.content}>
        <div className={classes.toolbar} />
        {props.children}
      </main>
    </div>
  );
}

const mapStateToProps = (state) => ({
  currentUser: state.user.currentUser,
});

const mapDispatchToProps = (dispatch) => ({
  setCurrentUser: (user) => dispatch(setCurrentUser(user)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AdminHeader);